var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-con"},[_c('dom-box',{attrs:{"box-style":{
      left: '1137px',
      bottom: '580px',
      width: '2139px',
      height: '1253px',
      borderRadius: 0,
      transform: 'scale(1.6)',
      background: 'transparent'
    },"content-type":"mainMap"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f6476f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page1/press1.vue
// module id = null
// module chunks = 